import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Table,
  Badge,
  Spinner, Pagination,
} from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Cookies from "es-cookie";
import "./_offlineExams.scss";
import { components } from 'react-select';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import * as XLSX from "xlsx";
import { withApollo } from "react-apollo";

const styles = {
  page: {
    // background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
    minHeight: "100vh",
    padding: "28px 24px",
  },
  statCard: {
    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    borderRadius: 16,
    padding: "20px 24px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 4px 20px rgba(99,102,241,0.3)",
    marginBottom: 24,
  },
  statLabel: { fontSize: 13, opacity: 0.85, marginBottom: 4, fontWeight: 400 },
  statValue: { fontSize: 36, fontWeight: 400, lineHeight: 1 },
  statIcon: {
    fontSize: 36,
    background: "rgba(255,255,255,0.2)",
    borderRadius: 12,
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
    border: "none",
    marginBottom: 24,
  },
  cardHeader: {
    border: "1px solid #e5e7eb",
    background: "rgba(250, 251, 255, 1)",
    color: "#000",
    padding: "18px 24px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  cardHeaderTitle: {
    color: "#000",
    fontWeight: 400,
    fontSize: 17,
    margin: 0,
  },
  cardHeaderIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    background: "rgb(224,231,255)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#6366f1",
    fontSize: 14,
  },
  cardBody: { padding: "22px 24px" },
  label: { fontSize: 12, fontWeight: 400, color: "#6b7280", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" },
  input: {
    borderRadius: 10,
    border: "1.5px solid #e5e7eb",
    padding: "9px 14px",
    fontSize: 14,
    color: "#1f2937",
    background: "#f9fafb",
    transition: "border-color 0.2s",
    width: "100%",
  },
  addBtn: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    border: "none",
    borderRadius: 10,
    padding: "9px 20px",
    fontWeight: 400,
    fontSize: 14,
    color: "#fff",
    width: "100%",
    boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
    cursor: "pointer",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  thead: {},
  th: {
    color: "#000",
    padding: "16px",
    fontSize: "14px",
    fontWeight: "600",
    whiteSpace: "nowrap",
    border: "1px solid #e5e7eb",
    background: "rgba(250, 251, 255, 1)",
  },
  td: {
    padding: "13px 16px",
    verticalAlign: "middle",
    fontSize: 14,
    color: "#374151",
    borderBottom: "1px solid #f3f4f6",
    border: "none",
  },
  idBadge: {
    background: "linear-gradient(135deg, #dbeafe, #ede9fe)",
    color: "#4f46e5",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 400,
    fontSize: 12,
    display: "inline-block",
    border: "1px solid #c7d2fe",
  },
  phaseName: { fontWeight: 400, color: "#1f2937" },
  standardPill: {
    background: "#f0fdf4",
    color: "#15803d",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 400,
    fontSize: 12,
    display: "inline-block",
    border: "1px solid #bbf7d0",
  },
  yearPill: {
    background: "#fff7ed",
    color: "#c2410c",
    borderRadius: 20,
    padding: "3px 12px",
    fontWeight: 400,
    fontSize: 12,
    display: "inline-block",
    border: "1px solid #fed7aa",
  },
  editBtn: {
    background: "linear-gradient(135deg, #f59e0b, #d97706)",
    border: "none",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 400,
    fontSize: 12,
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(245,158,11,0.3)",
  },
  saveBtn: {
    background: "linear-gradient(135deg, #10b981, #059669)",
    border: "none",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 400,
    fontSize: 12,
    color: "#fff",
    cursor: "pointer",
    marginRight: 6,
    boxShadow: "0 2px 8px rgba(16,185,129,0.3)",
  },
  cancelBtn: {
    background: "#f3f4f6",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "5px 14px",
    fontWeight: 400,
    fontSize: 12,
    color: "#6b7280",
    cursor: "pointer",
  },
  emptyState: {
    textAlign: "center",
    padding: "48px 20px",
    color: "#9ca3af",
  },
  emptyIcon: { fontSize: 48, marginBottom: 12, display: "block" },
  emptyText: { fontWeight: 400, fontSize: 15, color: "#6b7280", margin: 0 },
  emptySubText: { fontSize: 13, color: "#9ca3af", marginTop: 4 },
  filterRow: {
    display: "flex",
    gap: 12,
    alignItems: "flex-end",
    flexWrap: "wrap",
  },
  filterItem: { flex: "1 1 180px", minWidth: 160 },
  sectionDivider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    flexWrap: "wrap",
    gap: 12,
  },
  countChip: {
    background: "linear-gradient(135deg, #ede9fe, #dbeafe)",
    color: "#4f46e5",
    borderRadius: 20,
    padding: "4px 14px",
    fontWeight: 400,
    fontSize: 13,
    border: "1px solid #c7d2fe",
  },
  pageSizeSelect: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "1.5px solid #c084fc",
    background: "#f3e8ff",
    color: "#6b21a8",
    outline: "none",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 13,
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16,
    padding: "16px 20px",
    borderTop: "1px solid #e5e7eb",
    background: "#fff",
  },
  paginationInfo: {
    fontSize: 14,
    color: "#4b5563",
  },
  paginationButtons: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  pageBtn: {
    padding: "6px 12px",
    fontSize: 13,
    fontWeight: 600,
    borderRadius: 8,
    border: "1.5px solid #e5e7eb",
    background: "#fff",
    color: "#4b5563",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 36,
    height: 36,
  },
  pageBtnActive: {
    background: "#dee2e6",
    color: "#1f2937",
    borderColor: "#dee2e6",
  },
  pageBtnDisabled: {
    background: "#f3f4f6",
    color: "#d1d5db",
    borderColor: "#e5e7eb",
    cursor: "not-allowed",
  },
  errorPanel: {
    background: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: 12,
    padding: "14px 18px",
    marginBottom: 20,
  },
  errorPanelTitle: {
    color: "#b91c1c",
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 8,
  },
  errorList: {
    margin: 0,
    paddingLeft: 20,
    maxHeight: 220,
    overflowY: "auto",
    color: "#7f1d1d",
    fontSize: 13,
    lineHeight: 1.7,
  },
  errorMore: {
    color: "#7f1d1d",
    fontSize: 13,
    marginTop: 6,
  },
  noticePanel: {
    background: "#fffbeb",
    border: "1px solid #fde68a",
    borderRadius: 12,
    padding: "14px 18px",
    marginBottom: 20,
  },
  noticePanelTitle: {
    color: "#b45309",
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 8,
  },
  noticeList: {
    margin: 0,
    paddingLeft: 20,
    color: "#78350f",
    fontSize: 13,
    lineHeight: 1.7,
  },
};


const GET_MARKS_BY_SUBJECT = gql`
  query getMarksBySubject(
    $academic_year_id: Int!
    $exam_phase_id:Int!
    $branch_id: Int!
    $section_id: Int!
    $class_id:Int!
    $stream_id: Int
    $subject_ids:String
  ) {
    getMarksBySubject(
      academic_year_id: $academic_year_id
      exam_phase_id: $exam_phase_id
      branch_id: $branch_id
      section_id: $section_id
      class_id:$class_id
      stream_id: $stream_id
      subject_ids:$subject_ids
    ) {
       student_id
       roll_no
    student_name
      subject_id
  subject_name
  father_name
  father_phone
    mother_name
    student_mobile
  dob
  mother_phone
    exam_session_id
      internals {
      exam_marks_entry_id
      exam_phase_internal_id
      marks
      internal_name
      internal_max_marks
            subject_id
  subject_name
    }
    grade
    total_marks
    }
  }
`;

const SAVE_EXAM_MARKS = gql`
  mutation saveExamMarks(
    $marksInput: [ExamMarksInput!]!
    $inserted_by: Int
  ) {
    saveExamMarks(   
      marksInput: $marksInput
      inserted_by: $inserted_by
    )
  }
`;

const GET_EXAM_SESSIONS = gql`
  query getExamSessions($class_id:Int!,$stream_id:Int,$exam_phase_id:Int!){
    getExamSessions(
      exam_phase_id: $exam_phase_id
      class_id: $class_id
      stream_id: $stream_id
    ){
      exam_session_id
      subject_id
      subject_name
    }
  }
`;

const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                section_name
            }
        }
    }
`;

class MarksEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClass: "",
      selectedStream: "",
      selectedExamPhase: "",
      selectedSubject: [],
      selectedAcademicYear: "",
      loader: 0,
      loaderSubjects: 0,
      studentsData: [],
      remarksData: [
        { student_id: 1, roll_no: "5100000001", student_name: "Student 1", remarks: "" },
        { student_id: 2, roll_no: "5100000002", student_name: "Student 2", remarks: "" },
        { student_id: 3, roll_no: "5100000003", student_name: "Student 3", remarks: "" },
      ],
      isSubmitting: false,
      subjects: [],
      showConfig: false,
      currentPage: 1,
      rowsPerPage: 10,
      fetchIntenalLoader: 0,
      errors: {},
      selectedExamPhaseValue: "",
      selectedAcademicYearValue: "",
      min_marks: "",
      max_marks: "",
      grade: "",
      selectedClassValue: "",
      selectSection: "",
      branchData: [],
      uploadErrors: [],
      isDirty: false,
    };
  }

  componentDidMount() {
    this.getBranches();
    const firstYear = this.props.getYears?.[0];
    if (firstYear) {
      this.setState({ selectedAcademicYear: String(firstYear.id) });
    }
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    // Branch comes from the header (NavbarOne) — re-scope the branch list, which
    // is what the Class/Section options are built from.
    this.offBranchScope = onBranchScopeChange(() => this.getBranches());
  };

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.offBranchScope) this.offBranchScope();
  }

  // Guards against losing marks that were typed but never saved.
  handleBeforeUnload = (e) => {
    if (!this.state.isDirty) return undefined;
    e.preventDefault();
    e.returnValue = "";
    return "";
  };

  getBranches = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_BRANCHES,
        variables: { institution_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: "network-only",
      });
      // The header's branch selection IS this page's branch filter, and it never
      // widens past the branches the user is authorized for.
      const branches = scopeBranches(result.data.getBranches || []);
      this.setState((prev) => {
        // A Section picked before the scope narrowed may no longer exist in it.
        const stillValid = branches.some((b) =>
          (b.sections || []).some((s) => String(s.id) === String(prev.selectSection))
        );
        return stillValid
          ? { branchData: branches }
          : { branchData: branches, selectSection: "", showConfig: false, studentsData: [] };
      });
    } catch {
      // ignore
    }
  };

  // The branch that owns the chosen Section. There is no Branch dropdown any more:
  // a section belongs to exactly one branch, so the branch_id the marks services
  // expect is derived from the section rather than picked separately.
  getSelectedBranchId = () => {
    const branch = (this.state.branchData || []).find((b) =>
      (b.sections || []).some((s) => String(s.id) === String(this.state.selectSection))
    );
    return branch ? branch.id : null;
  };


  handleDropdown = (field, e) => {
    const value = e.target.value;

    this.setState(
      {
        [field]: value,
        showConfig: false,
        mainSubjects: [],
      },
      () => {
        const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;

        if (field === "selectedSubject") {
          if (selectedClass && selectedExam && selectedAcademicYear && selectedSubject) {
            this.handleFetchData();
          }
        } else {
          if (selectedClass && selectedExam && selectedAcademicYear) {
            this.handleFetchSubject();
          }
        }
      }
    );
  };

  handleSelectChange = (name, value) => {
    // Changing any non-subject filter invalidates the current subject selection.
    const extraReset =
      name === "selectedSubject"
        ? {}
        : { selectedSubject: [], ...(name === "selectedClass" ? { selectedStream: "" } : {}) };

    this.setState(
      { [name]: value, showConfig: false, mainSubjects: [], ...extraReset },
      () => {
        const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;
        if (name === "selectedSubject") {
          if (selectedClass && selectedExam && selectedAcademicYear && selectedSubject?.length) {
            this.handleFetchData();
          }
        } else {
          if (selectedClass && selectedExam && selectedAcademicYear) {
            this.handleFetchSubject();
          }
        }
      }
    );
  };

  sortSubjectsByName = (subjects) =>
    [...(subjects || [])].sort((a, b) =>
      Number(a.subject_id ?? 0) - Number(b.subject_id ?? 0)
    );

  handleFetchSubject = async () => {
    const { selectedClass, selectedExam, selectedAcademicYear, } = this.state;

    if (!selectedClass || !selectedExam || !selectedAcademicYear) {
      return; // ❌ no toast here (avoid spam)
    }

    this.setState({ loaderSubjects: 1 });

    try {
      const res = await this.props.client.query({
        query: GET_EXAM_SESSIONS,
        variables: {
          exam_phase_id: +selectedExam,
          class_id: +selectedClass,
          stream_id: this.state.selectedStream ? +this.state.selectedStream : null,
        },
        fetchPolicy: "no-cache",
      });

      const apiData = res?.data?.getExamSessions || [];

      this.setState({
        subjects: this.sortSubjectsByName(apiData),
        showConfig: false,
        currentPage: 1,
      });

    } catch (err) {
      console.error(err);
      toast.error("No subjects available");
    } finally {
      this.setState({ loaderSubjects: 0 });
    }
  };

  handleFetchData = async ({ preservePage = false } = {}) => {
    const { selectedClass, selectedExam, selectedAcademicYear, selectedSubject } = this.state;

    if (!selectedClass || !selectedExam || !selectedAcademicYear || !selectedSubject?.length) {
      toast.error("Please select all filters");
      return;
    }

    this.setState(prev => ({
      ...prev,
      loader: 1,
    }));

    try {
      const res = await this.props.client.query({
        query: GET_MARKS_BY_SUBJECT,
        variables: {
          academic_year_id: +this.state.selectedAcademicYear,
          exam_phase_id: +this.state.selectedExam,
          branch_id: +this.getSelectedBranchId(),
          section_id: +this.state.selectSection,
          class_id: +this.state.selectedClass,
          stream_id: this.state.selectedStream ? +this.state.selectedStream : null,
          subject_ids: (this.state.selectedSubject || []).join(","),
        },
        fetchPolicy: "no-cache",
      });

      const apiData = this.normalizeMarksData(res?.data?.getMarksBySubject || []);

      const preparedRemarksData = apiData.map((item) => ({
        ...item,
        remarks: item.remarks || "",
      }));

      this.setState((prev) => ({
        studentsData: apiData,
        remarksData: preparedRemarksData,
        showConfig: true,
        currentPage: preservePage ? prev.currentPage : 1,
        isSubmitting: false,
        uploadErrors: [],
        isDirty: false,
      }));

    } catch (err) {
      console.error(err);
      toast.error("Unable to load student marks. Please try again.");
    } finally {
      this.setState(prev => ({
        ...prev,
        loader: 0,
        isSubmitting: false,
      }))
    }
  };

  /* ================= DATA + COLUMN MODEL =================
     getMarksBySubject returns a flat row per (student, subject), but each row's
     internals[] spans EVERY selected subject, and exam_phase_internal_id is
     reused across subjects (the same test id 158 appears for Maths, Chemistry
     and Physics). A cell is therefore identified by (subject_id,
     exam_phase_internal_id) — never by exam_phase_internal_id alone.

     normalizeMarksData collapses the API response into one row per student with
     a de-duplicated internals[] whose entries each carry their own subject_id.
     Everything downstream (grid, export, import, save payload) works on that. */

  cellKey = (subjectId, examPhaseInternalId) => `${subjectId}::${examPhaseInternalId}`;

  normalizeMarksData = (apiData) => {
    const rows = [];
    const byStudent = new Map();

    (apiData || []).forEach((row) => {
      const studentKey = String(row.student_id);
      let entry = byStudent.get(studentKey);

      if (!entry) {
        // exam_session_id is per (student, subject); keep them all so each
        // internal can be saved against the session its subject belongs to.
        entry = { ...row, internals: [], exam_session_ids: {} };
        byStudent.set(studentKey, entry);
        rows.push(entry);
      }

      if (row.exam_session_id !== null && row.exam_session_id !== undefined) {
        entry.exam_session_ids[String(row.subject_id)] = row.exam_session_id;
      }

      const seen = new Set(
        entry.internals.map((i) => this.cellKey(i.subject_id, i.exam_phase_internal_id))
      );

      (row.internals || []).forEach((int) => {
        const subjectId = int.subject_id ?? row.subject_id;
        const key = this.cellKey(subjectId, int.exam_phase_internal_id);
        if (seen.has(key)) return;
        seen.add(key);

        entry.internals.push({
          ...int,
          subject_id: subjectId,
          subject_name: int.subject_name || row.subject_name || "",
        });
      });
    });

    rows.forEach((row) => {
      row.total_marks = row.internals.reduce((sum, i) => sum + (Number(i.marks) || 0), 0);
    });

    return rows;
  };

  buildInternalColumns = (studentsData) => {
    const columns = [];
    const seen = new Set();

    (studentsData || []).forEach((row) => {
      (row.internals || []).forEach((int) => {
        const key = this.cellKey(int.subject_id, int.exam_phase_internal_id);
        if (seen.has(key)) return;
        seen.add(key);

        columns.push({
          key,
          subject_id: int.subject_id,
          subject_name: int.subject_name || "",
          exam_phase_internal_id: int.exam_phase_internal_id,
          internal_name: int.internal_name,
          internal_max_marks: int.internal_max_marks,
          label: this.marksColumnLabel(int.subject_name, int),
        });
      });
    });

    // Group the columns by subject so a subject's tests sit together.
    return columns.sort(
      (a, b) =>
        Number(a.subject_id) - Number(b.subject_id) ||
        Number(a.exam_phase_internal_id) - Number(b.exam_phase_internal_id)
    );
  };

  /* Single source of truth for a marks column caption. The grid header, the
     Excel export and the Excel import all derive their key from this one
     function — that is what makes the download -> edit -> upload round trip
     work without the user touching the file's structure. */
  marksColumnLabel = (subjectName, internal) =>
    `${subjectName}-${internal.internal_name} - (${internal.internal_max_marks})`;

  // Tolerant key for header matching: case/spacing/punctuation differences that
  // Excel introduces must not fail an otherwise valid file.
  normalizeExcelText = (value) =>
    String(value ?? "").trim().toLowerCase().replace(/\s+/g, " ");

  normalizeHeaderKey = (value) =>
    this.normalizeExcelText(value).replace(/[\s\-_]/g, "");

  // Same key with the trailing "(max marks)" hint dropped, so a template whose
  // max marks were re-configured after download still maps to its column.
  headerKeyWithoutMax = (value) =>
    this.normalizeHeaderKey(String(value ?? "").replace(/\(\s*[\d.]+\s*\)\s*$/, ""));

  getSelectedExamPhaseName = () =>
    this.props.getExamPhase?.find((item) => +item.id === +this.state.selectedExam)?.exam_phase || "";

  getSelectedClassName = () =>
    this.props.getClasses?.find((item) => +item.id === +this.state.selectedClass)?.class || "";

  getSelectedSectionName = () =>
    (this.state.branchData || [])
      .flatMap((b) => b.sections || [])
      .find((s) => String(s.id) === String(this.state.selectSection))
      ?.section_name || "";

  /* ================= MARKS ENTRY ================= */

  // Throttled so holding a key down in a number field can't produce a toast storm.
  notifyInvalidMarks = (message) => {
    const now = Date.now();
    if (this._lastMarksToastAt && now - this._lastMarksToastAt < 1500) return;
    this._lastMarksToastAt = now;
    toast.error(message);
  };

  handleMarksChange = (flatRowIndex, subjectId, examPhaseInternalId, rawValue) => {
    const value = String(rawValue ?? "");
    const cellKey = this.cellKey(subjectId, examPhaseInternalId);

    // Match on subject + test: exam_phase_internal_id is shared across subjects,
    // so matching on it alone would write the same mark into every subject.
    const target = (this.state.studentsData[flatRowIndex]?.internals || []).find(
      (i) => this.cellKey(i.subject_id, i.exam_phase_internal_id) === cellKey
    );

    if (!target) return;

    // Validate before committing, but keep "" valid so a mark can be cleared.
    if (value !== "") {
      const num = Number(value);
      if (!Number.isFinite(num)) {
        this.notifyInvalidMarks("Marks must be a number");
        return;
      }
      if (num < 0) {
        this.notifyInvalidMarks("Marks cannot be negative");
        return;
      }
      if (num > Number(target.internal_max_marks)) {
        this.notifyInvalidMarks(`Marks cannot exceed max marks (${target.internal_max_marks})`);
        return;
      }
    }

    this.setState((prev) => {
      const updated = [...prev.studentsData];
      const row = { ...updated[flatRowIndex] };

      row.internals = (row.internals || []).map((i) =>
        this.cellKey(i.subject_id, i.exam_phase_internal_id) === cellKey
          ? { ...i, marks: value }
          : i
      );
      row.total_marks = row.internals.reduce((sum, i) => sum + (Number(i.marks) || 0), 0);
      updated[flatRowIndex] = row;

      return { studentsData: updated, isDirty: true };
    });
  };

  // Whole-grid validation, reused by Save. Returns human-readable messages.
  validateAllMarks = () => {
    const messages = [];

    (this.state.studentsData || []).forEach((student) => {
      (student.internals || []).forEach((int) => {
        const raw = int.marks;
        if (raw === "" || raw === null || raw === undefined) return;

        const num = Number(raw);
        const where = `${student.student_name} (Roll No ${student.roll_no}) — ${int.subject_name || student.subject_name} ${int.internal_name}`;

        if (!Number.isFinite(num)) {
          messages.push(`${where}: "${raw}" is not a valid number`);
        } else if (num < 0) {
          messages.push(`${where}: marks cannot be negative`);
        } else if (num > Number(int.internal_max_marks)) {
          messages.push(`${where}: ${num} exceeds max marks (${int.internal_max_marks})`);
        }
      });
    });

    return messages;
  };

  /* ================= EXCEL DOWNLOAD ================= */

  handleDownloadExcel = () => {
    const { studentsData } = this.state;

    if (!studentsData.length) {
      toast.error("Nothing to export — no students loaded for the selected filters.");
      return;
    }

    const examPhaseName = this.getSelectedExamPhaseName();
    const className = this.getSelectedClassName();
    const sectionName = this.getSelectedSectionName();
    const internalColumns = this.buildInternalColumns(studentsData);

    // Fixed identity columns first, then one column per selected test.
    // One row per student; each subject/test is its own column, so the subject
    // lives in the column header rather than in a per-row field.
    const headers = [
      "student_id",
      "roll_no",
      "student_name",
      "class_name",
      "section_name",
      "exam_phase_name",
      ...internalColumns.map((c) => c.label),
    ];

    // studentsData is already scoped to the selected exam phase / class /
    // section / subjects by the query, so exporting it verbatim exports exactly
    // the current filter and nothing else.
    const data = studentsData.map((s) => {
      const row = {
        student_id: s.student_id,
        roll_no: s.roll_no,
        student_name: s.student_name,
        class_name: className,
        section_name: sectionName,
        exam_phase_name: examPhaseName,
      };

      // A test this student has no entry for stays blank; import skips blanks.
      internalColumns.forEach((c) => {
        row[c.label] = "";
      });

      (s.internals || []).forEach((int) => {
        const label = this.marksColumnLabel(int.subject_name, int);
        row[label] = int.marks === null || int.marks === undefined ? "" : int.marks;
      });

      return row;
    });

    const ws = XLSX.utils.json_to_sheet(data, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Marks");

    const fileName = ["Marks", examPhaseName, className, sectionName]
      .filter(Boolean)
      .map((part) => String(part).replace(/[\\/:*?"<>|]/g, "").trim().replace(/\s+/g, "_"))
      .join("_");

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  /* ================= EXCEL UPLOAD ================= */

  handleUploadExcel = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Reset so the same file can be re-uploaded
    e.target.value = "";

    const reader = new FileReader();

    reader.onerror = () => toast.error("Could not read the selected file.");

    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const wb = XLSX.read(data, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(ws, { defval: "" });

        this.applyExcelData(jsonData);
      } catch (err) {
        console.error(err);
        toast.error("Could not parse the selected file. Please upload the downloaded template.");
      }
    };

    reader.readAsArrayBuffer(file);
  };

   

  /* Import walks the uploaded rows (not the loaded students) so that every
     problem is reported against its real spreadsheet row number, and so a
     partial file only touches the students it actually contains. Nothing is
     committed unless the whole file validates. */
  applyExcelData = (excelData) => {
    const { studentsData } = this.state;
    const errors = [];

    if (!studentsData.length) {
      toast.error("Load students for the selected filters before uploading marks.");
      return;
    }

    if (!excelData.length) {
      this.setState({ uploadErrors: ["The uploaded file contains no data rows."] });
      toast.error("The uploaded file contains no data rows.");
      return;
    }

    // Union of every row's keys — a sparse first row must not hide columns.
    const excelHeaders = [...new Set(excelData.flatMap((row) => Object.keys(row)))];

    const headerByKey = new Map();
    const headerByKeyNoMax = new Map();
    excelHeaders.forEach((h) => {
      const key = this.normalizeHeaderKey(h);
      const keyNoMax = this.headerKeyWithoutMax(h);
      if (!headerByKey.has(key)) headerByKey.set(key, h);
      if (!headerByKeyNoMax.has(keyNoMax)) headerByKeyNoMax.set(keyNoMax, h);
    });

    const findHeader = (label) =>
      headerByKey.get(this.normalizeHeaderKey(label)) ??
      headerByKeyNoMax.get(this.headerKeyWithoutMax(label));

    const idHeader = findHeader("student_id");
    const rollHeader = findHeader("roll_no");

    const fail = (message) => {
      this.setState({ uploadErrors: [message] });
      toast.error(message);
    };

    if (!idHeader && !rollHeader) {
      fail('Invalid file: no "student_id" or "roll_no" column found. Please upload the downloaded template.');
      return;
    }

    // One grid row per student, so a student identifier alone locates the row.
    // The subject lives in the column headers, not in a per-row field.
    const studentIndex = new Map();
    studentsData.forEach((student, flatIndex) => {
      [student.student_id, student.roll_no].forEach((identifier) => {
        if (identifier === null || identifier === undefined) return;
        const id = String(identifier).trim();
        if (id === "") return;
        if (!studentIndex.has(id)) studentIndex.set(id, flatIndex);
      });
    });

    // flatIndex -> Map(cellKey -> marks)
    const stagedUpdates = new Map();
    let marksCount = 0;

    excelData.forEach((row, index) => {
      const rowNumber = index + 2; // +1 for the header row, +1 because rows are 1-based

      const identifier = [idHeader && row[idHeader], rollHeader && row[rollHeader]]
        .map((v) => (v === null || v === undefined || v === false ? "" : String(v).trim()))
        .find((v) => v !== "");

      if (!identifier) {
        errors.push(`Row ${rowNumber}: Missing Student ID / Roll Number.`);
        return;
      }

      const flatIndex = studentIndex.get(identifier);

      if (flatIndex === undefined) {
        errors.push(`Row ${rowNumber}: Student ID ${identifier} not found.`);
        return;
      }

      const student = studentsData[flatIndex];

      (student.internals || []).forEach((int) => {
        const label = this.marksColumnLabel(int.subject_name, int);
        const column = findHeader(label);

        // Column absent from the file, or blank on this row: leave marks as-is.
        if (!column) return;
        const raw = row[column];
        if (raw === null || raw === undefined || String(raw).trim() === "") return;

        const num = Number(String(raw).trim());

        if (!Number.isFinite(num)) {
          errors.push(`Row ${rowNumber}: Invalid numeric value "${raw}" for "${label}".`);
          return;
        }
        if (num < 0) {
          errors.push(`Row ${rowNumber}: Marks cannot be negative for "${label}".`);
          return;
        }
        if (num > Number(int.internal_max_marks)) {
          errors.push(
            `Row ${rowNumber}: Marks ${num} exceed the maximum allowed (${int.internal_max_marks}) for "${label}".`
          );
          return;
        }

        if (!stagedUpdates.has(flatIndex)) stagedUpdates.set(flatIndex, new Map());
        stagedUpdates
          .get(flatIndex)
          .set(this.cellKey(int.subject_id, int.exam_phase_internal_id), num);
        marksCount += 1;
      });
    });

    if (errors.length > 0) {
      this.setState({ uploadErrors: errors });
      toast.error(
        `Upload failed: ${errors.length} problem${errors.length > 1 ? "s" : ""} found. No marks were changed.`
      );
      return;
    }

    if (stagedUpdates.size === 0) {
      this.setState({ uploadErrors: [] });
      toast.warn("No marks found in the uploaded file.");
      return;
    }

    // Only the affected rows are rebuilt — everything else keeps its identity,
    // so the grid re-renders the imported students and nothing more.
    this.setState(
      (prev) => ({
        studentsData: prev.studentsData.map((student, flatIndex) => {
          const updates = stagedUpdates.get(flatIndex);
          if (!updates) return student;

          const internals = (student.internals || []).map((int) => {
            const key = this.cellKey(int.subject_id, int.exam_phase_internal_id);
            return updates.has(key) ? { ...int, marks: updates.get(key) } : int;
          });

          return {
            ...student,
            internals,
            total_marks: internals.reduce((sum, i) => sum + (Number(i.marks) || 0), 0),
          };
        }),
        uploadErrors: [],
        isSubmitting: false,
        isDirty: true,
      }),
      () => {
        toast.success(
          `Imported ${marksCount} mark${marksCount > 1 ? "s" : ""} for ${stagedUpdates.size} student record${stagedUpdates.size > 1 ? "s" : ""}. Click Save to persist.`
        );
      }
    );
  };
  /* ================= PAGINATION ================= */

  getTotalPages = () => {
    const { studentsData, rowsPerPage } = this.state;
    if (rowsPerPage === "All") return 1;
    return Math.ceil(studentsData.length / (parseInt(rowsPerPage, 10) || 10)) || 1;
  };

  // Clamped so the grid and the pagination footer always agree on the page.
  getActivePage = () => Math.min(Math.max(this.state.currentPage, 1), this.getTotalPages());

  // Offset of the first visible row within studentsData. Row handlers map their
  // visible index through this to reach the correct flat row.
  getPageStartIndex = () => {
    const { rowsPerPage } = this.state;
    if (rowsPerPage === "All") return 0;
    return (this.getActivePage() - 1) * (parseInt(rowsPerPage, 10) || 10);
  };

  getPaginatedData = () => {
    const { studentsData, rowsPerPage } = this.state;
    if (rowsPerPage === "All") return studentsData;
    const start = this.getPageStartIndex();
    return studentsData.slice(start, start + (parseInt(rowsPerPage, 10) || 10));
  };

  renderPagination = () => {
    const { studentsData, rowsPerPage, currentPage } = this.state;
    if (!studentsData || studentsData.length === 0) return null;

    const rowsPerPageNum = rowsPerPage === "All" ? studentsData.length : parseInt(rowsPerPage, 10);
    const totalPages = rowsPerPage === "All" ? 1 : Math.ceil(studentsData.length / rowsPerPageNum) || 1;

    let activePage = currentPage;
    if (activePage > totalPages) {
      activePage = totalPages;
    }
    if (activePage < 1) {
      activePage = 1;
    }

    const startIndex = rowsPerPage === "All" ? 0 : (activePage - 1) * rowsPerPageNum;
    const showingStart = studentsData.length === 0 ? 0 : startIndex + 1;
    const showingEnd = Math.min(startIndex + rowsPerPageNum, studentsData.length);
    const showingText = `Showing ${showingStart} to ${showingEnd} of ${studentsData.length} Results`;

    const pageNumbers = [];
    const maxVisibleButtons = 5;
    let startPage = Math.max(1, activePage - Math.floor(maxVisibleButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
    if (endPage - startPage + 1 < maxVisibleButtons) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      if (i >= 1 && i <= totalPages) {
        pageNumbers.push(i);
      }
    }

    return (
      <div style={styles.paginationContainer}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <select
            style={styles.pageSizeSelect}
            value={rowsPerPage}
            onChange={(e) => {
              const val = e.target.value;
              this.setState({
                rowsPerPage: val === "All" ? "All" : parseInt(val, 10),
                currentPage: 1,
              });
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value="All">All</option>
          </select>
          <div style={styles.paginationInfo}>{showingText}</div>
        </div>
        <div style={styles.paginationButtons}>
          <button
            type="button"
            style={{
              ...styles.pageBtn,
              ...(activePage === 1 ? styles.pageBtnDisabled : {}),
            }}
            disabled={activePage === 1}
            onClick={() => this.setState({ currentPage: activePage - 1 })}
          >
            <i className="fa fa-chevron-left" style={{ fontSize: 11 }} />
          </button>

          {startPage > 1 && (
            <>
              <button
                type="button"
                style={{
                  ...styles.pageBtn,
                  ...(activePage === 1 ? styles.pageBtnActive : {}),
                }}
                onClick={() => this.setState({ currentPage: 1 })}
              >
                1
              </button>
              {startPage > 2 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
            </>
          )}

          {pageNumbers.map((page) => (
            <button
              key={page}
              type="button"
              style={{
                ...styles.pageBtn,
                ...(activePage === page ? styles.pageBtnActive : {}),
              }}
              onClick={() => this.setState({ currentPage: page })}
            >
              {page}
            </button>
          ))}

          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && <span style={{ color: "#9ca3af", padding: "0 4px" }}>...</span>}
              <button
                type="button"
                style={{
                  ...styles.pageBtn,
                  ...(activePage === totalPages ? styles.pageBtnActive : {}),
                }}
                onClick={() => this.setState({ currentPage: totalPages })}
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            type="button"
            style={{
              ...styles.pageBtn,
              ...(activePage === totalPages ? styles.pageBtnDisabled : {}),
            }}
            disabled={activePage === totalPages}
            onClick={() => this.setState({ currentPage: activePage + 1 })}
          >
            <i className="fa fa-chevron-right" style={{ fontSize: 11 }} />
          </button>
        </div>
      </div>
    );
  };

  handleGradeChange = (studentIndex, value) => {
    this.setState((prev) => {
      const updated = [...prev.studentsData];

      updated[studentIndex].grade = value;

      return { studentsData: updated };
    });
  };

  formatPayload = () => {
    const { studentsData } = this.state;

    const payload = [];

    studentsData.forEach((student) => {
      (student.internals || []).forEach((int) => {
        const isBlank = int.marks === "" || int.marks === null || int.marks === undefined;

        // A blank cell that was never saved before has nothing to persist —
        // sending it would create a spurious zero-mark record.
        if (isBlank && !int.exam_marks_entry_id) return;

        // exam_phase_internal_id is shared across subjects, so the session must
        // come from THIS internal's subject — using the row's single
        // exam_session_id would file every subject's marks under one session.
        const examSessionId =
          student.exam_session_ids?.[String(int.subject_id)] ?? student.exam_session_id;

        payload.push({
          id: int.exam_marks_entry_id || null,
          edu_student_id: student.student_id,
          exam_session_id: examSessionId,
          exam_phase_internal_id: int.exam_phase_internal_id,
          marks: isBlank ? 0 : Number(int.marks),
        });
      });
    });

    return payload;
  };

  handleSave = async () => {
    const validationErrors = this.validateAllMarks();

    if (validationErrors.length > 0) {
      this.setState({ uploadErrors: validationErrors });
      toast.error(
        `Cannot save: ${validationErrors.length} invalid mark${validationErrors.length > 1 ? "s" : ""}. Please correct the highlighted entries.`
      );
      return;
    }

    const payload = this.formatPayload();

    if (!payload.length) {
      toast.warn("No marks to save.");
      return;
    }

    this.setState({ isSubmit: true, uploadErrors: [] });

    try {
      const response = await this.props.saveExamMarks({
        variables: {
          marksInput: payload,
          inserted_by: parseInt(Cookies.get("id")),
        },
      });

      if (response?.data?.saveExamMarks) {
        // Clear the unsaved-changes guard only once the server has accepted the
        // marks, then re-read just this filter's rows — the page is not reloaded
        // and the current page/page-size are preserved.
        this.setState({ isDirty: false });
        toast.success("Marks saved successfully!");
        await this.handleFetchData({ preservePage: true });
      } else {
        toast.error("Marks could not be saved. Please try again.");
      }
    } catch (error) {
      console.error("Error saving marks:", error);
      toast.error("Error saving marks. Your entries have been kept — please try again.");
    } finally {
      this.setState({ isSubmit: false, isSubmitting: false });
    }
  };


  sortClassesByName = (classes) =>
    [...(classes || [])].sort((a, b) =>
      String(a.value ?? "").localeCompare(
        String(b.value ?? ""),
        undefined,
        { sensitivity: "base", numeric: true }
      )
    );

  sortSectionsByName = (sections) =>
    [...(sections || [])].sort((a, b) =>
      String(a.value ?? "").localeCompare(
        String(b.value ?? ""),
        undefined,
        { sensitivity: "base", numeric: true }
      )
    );




  render() {
    const { studentsData, showConfig, loader, getExamPhaseGradingScaleData, branchData, selectSection, selectedClass } = this.state;

    // Class / Section options now span every branch the header has in scope,
    // instead of the one branch a local dropdown used to pick.
    const scopedSections = (branchData || []).flatMap((b) => b.sections || []);

    // Class Array
    const classArr = this.sortClassesByName(
      [...new Set(scopedSections.map((s) => s.class_id))]
        .map((classId) => {
          const classData = this.props.getClasses.find(
            (c) => c.id === classId
          );

          return classData
            ? {
              value: classData.id,
              label: classData.class,
              id: classData.id,
            }
            : null;
        })
        .filter(Boolean)
    );

    // Stream options derived from selected class
    const streamArr = (() => {
      const { getStreams } = this.props;
      if (!getStreams?.length || !selectedClass) return [];
      const classId = Number(selectedClass);
      return (getStreams || [])
        .filter((st) => {
          const classCsv = String(st.classes || "").split(",").map((v) => Number(v.trim())).filter(Boolean);
          return classCsv.includes(classId);
        })
        .map((st) => ({ value: st.id, label: st.stream, id: st.id }));
    })();

    // Section Array based on selected class
    const sectionArr = this.sortSectionsByName(
      scopedSections
        .filter(
          (s) =>
            !selectedClass ||
            String(s.class_id) === String(selectedClass)
        )
        .map((s) => ({
          value: s.id,
          label: s.section_name,
          class_id: s.class_id,
          id: s.id,
        }))
    );

    const selectedExamPhaseName = this.props.getExamPhase?.find(
      (item) => +item.id === +this.state.selectedExam
    )?.exam_phase || "";

    const selectedSubjectValues = (this.state.selectedSubject || []).map(String);
    const selectedSubjectName = (this.state.subjects || [])
      .filter((item) => selectedSubjectValues.includes(String(item.subject_id)))
      .map((item) => item.subject_name)
      .join(", ");

    const paginatedData = this.getPaginatedData();
    const pageStartIndex = this.getPageStartIndex();
    const internalColumns = this.buildInternalColumns(studentsData);
    const { uploadErrors } = this.state;

    /* A selected subject only produces marks columns if getMarksBySubject
       returned rows for it AND those rows carry internals. Report the subjects
       that produced neither, so "I picked two subjects but see one column"
       is explained in the UI instead of looking like a rendering bug. */
    const selectedSubjectOptions = (this.state.subjects || []).filter((s) =>
      selectedSubjectValues.includes(String(s.subject_id))
    );

    const subjectDiagnostics = selectedSubjectOptions
      .filter(
        (s) => !internalColumns.some((c) => String(c.subject_id) === String(s.subject_id))
      )
      .map((s) => ({ subject: s, rowCount: studentsData.length }));

    return (
      <div style={styles.page}>
        {/* Top Section */}

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.cardHeaderIcon}>
              <i className="fas fa-book-open" />
            </div>
            <h5 style={styles.cardHeaderTitle}>Subject Wise Mark Entry Configuration</h5>
          </div>

          <div style={styles.cardBody}>
            <Row className="g-3">
              {/* Academic Year */}
              <Col xs={12} sm={6} md={4}>
                <div style={styles.label}>Academic Year</div>
                <SelectDropDown
                  name="selectedAcademicYear"
                  placeholderName="Select Academic Year"
                  options={(this.props.getYears)?.map(year => ({
                    value: year.id,
                    label: year.academic_year,
                    id: year.id,
                  }))}
                  isClearable={false}
                  stateData={
                    this.state.selectedAcademicYear
                      ? ((this.props.getYears)?.map(year => ({
                        value: year.id,
                        label: year.academic_year,
                        id: year.id,
                      })).find(o => String(o.value) === String(this.state.selectedAcademicYear)) || null)
                      : null
                  }
                  handleChange={this.handleSelectChange}

                />
              </Col>

              {/* No Branch filter — the header's branch selection scopes this page. */}

              {/* Class */}
              <Col xs={12} sm={6} md={4}>
                <div style={styles.label}>Select Class</div>
                <SelectDropDown
                  name="selectedClass"
                  placeholderName="Select Class"
                  options={classArr}
                  stateData={
                    this.state.selectedClass
                      ? (classArr.find(o => String(o.value) === String(this.state.selectedClass)) || null)
                      : null
                  }
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              {/* Stream */}
              {streamArr.length > 0 && (
                <Col xs={12} sm={6} md={4} className="mt-2">
                  <div style={styles.label}>Select Stream</div>
                  <SelectDropDown
                    name="selectedStream"
                    placeholderName="Select Stream"
                    options={streamArr}
                    stateData={
                      this.state.selectedStream
                        ? (streamArr.find(o => String(o.value) === String(this.state.selectedStream)) || null)
                        : null
                    }
                    handleChange={this.handleSelectChange}
                    isClearable={false}
                  />
                </Col>
              )}

              <Col xs={12} sm={6} md={4} className="mt-2">
                <div style={styles.label}>Select Section</div>
                <SelectDropDown
                  name="selectSection"
                  placeholderName="Select Section"
                  options={sectionArr}
                  stateData={
                    this.state.selectSection
                      ? (sectionArr.find(o => String(o.value) === String(this.state.selectSection)) || null)
                      : null
                  }
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                  isDisabled={!this.state.selectedClass}
                />
              </Col>

              {/* Exam Phase */}
              <Col xs={12} sm={6} md={3} className="mt-2">
                <div style={styles.label}>Exam Phase</div>
                {(() => {
                  const examOptions = (
                    this.props.getExamPhase?.filter(
                      (item) => +item.academic_year_id === +this.state.selectedAcademicYear
                    )
                  )?.map(item => ({
                    value: item.id,
                    label: `${item.exam_phase} - ${item.exam_standard_name}`,
                    id: item.id,
                  })) || [];
                  return (
                    <SelectDropDown
                      name="selectedExam"
                      placeholderName="Select Exam Phase"
                      options={examOptions}
                      stateData={
                        this.state.selectedExam
                          ? (examOptions.find(o => String(o.value) === String(this.state.selectedExam)) || null)
                          : null
                      }
                      handleChange={this.handleSelectChange}
                      isClearable={false}
                    />
                  );
                })()}
              </Col>

              {
                this.state.loaderSubjects === 1 ? (
                  <Col xs={12} sm={6} md={3}>
                    <Spinner animation="border" />
                  </Col>
                ) : (
                  <Col xs={12} sm={6} md={3} className="mt-2">
                    <div style={styles.label}>Select Subject</div>
                    {(() => {
                      const subjectOptions = (this.state.subjects)?.map(cls => ({
                        value: cls.subject_id,
                        label: cls.subject_name,
                        id: cls.exam_session_id,
                      })) || [];
                      const selectedSubjectValues = (this.state.selectedSubject || []).map(String);
                      return (
                        <SelectDropDown
                          name="selectedSubject"
                          placeholderName="Select Subject"
                          options={subjectOptions}
                          isMulti
                          stateData={subjectOptions.filter(o =>
                            selectedSubjectValues.includes(String(o.value))
                          )}
                          handleChange={this.handleSelectChange}
                          isClearable={false}
                        />
                      );
                    })()}
                  </Col>
                )
              }
            </Row>

            {/* Loader */}
            {this.state.loader === 1 && (
              <div className="py-4">
                <style>
                  {`
                      @keyframes shimmerLoading {
                          0% { background-position: -1000px 0; }
                          100% { background-position: 1000px 0; }
                      }
                      .shimmer-line {
                          height: 20px;
                          margin-bottom: 15px;
                          background: #f6f7f8;
                          background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                          background-repeat: no-repeat;
                          background-size: 1000px 100%;
                          animation: shimmerLoading 1.5s infinite linear forwards;
                          border-radius: 4px;
                      }
                      .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                  `}
                </style>
                <div className="shimmer-line shimmer-header" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '80%' }}></div>
              </div>
            )}

            {!this.state.loader && this.state.showConfig && (
              <div style={styles.card} className="mt-5">
                <div style={{ ...styles.cardHeader, position: "relative" }}>
                  <div style={styles.cardHeaderDot}></div>
                  <h5 style={styles.cardHeaderTitle}>
                    Student Marks Entry
                  </h5>

                  <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", display: "flex", alignItems: "center" }}>
                    <Badge style={{ background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)", color: "#fff", padding: "8px 16px", borderRadius: "20px", fontSize: "13px", fontWeight: 500, boxShadow: "0 2px 8px rgba(99,102,241,0.2)" }}>
                      {selectedExamPhaseName} • {selectedSubjectName}
                    </Badge>
                  </div>

                  <div style={{ marginLeft: "auto" }}>
                    <button style={styles.editBtn} onClick={this.handleDownloadExcel}>
                      Excel Download
                    </button>

                    <button style={{ ...styles.saveBtn, marginLeft: 10 }} onClick={() => this.fileInput.click()}
                    >
                      Excel Upload
                    </button>

                    <input
                      type="file"
                      ref={(r) => (this.fileInput = r)}
                      style={{ display: "none" }}
                      onChange={this.handleUploadExcel}
                    />
                  </div>
                </div>

                <div style={styles.cardBody}>
                  {subjectDiagnostics.length > 0 && (
                    <div style={styles.noticePanel}>
                      <div style={styles.noticePanelTitle}>
                        <i className="fas fa-info-circle" style={{ marginRight: 8 }} />
                        {subjectDiagnostics.length} selected subject
                        {subjectDiagnostics.length > 1 ? "s have" : " has"} no marks column
                      </div>
                      <ul style={styles.noticeList}>
                        {subjectDiagnostics.map(({ subject, rowCount }) => (
                          <li key={subject.subject_id}>
                            <strong>{subject.subject_name}</strong>{" "}
                            {rowCount === 0
                              ? "— no student records were returned for this exam phase, class and section."
                              : "— no internal tests were returned for this subject in this exam phase, so there is nothing to enter marks against."}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {uploadErrors.length > 0 && (
                    <div style={styles.errorPanel}>
                      <div style={styles.errorPanelTitle}>
                        <i className="fas fa-exclamation-triangle" style={{ marginRight: 8 }} />
                        {uploadErrors.length} issue{uploadErrors.length > 1 ? "s" : ""} found — no marks were changed
                      </div>
                      <ul style={styles.errorList}>
                        {uploadErrors.slice(0, 50).map((message, i) => (
                          <li key={i}>{message}</li>
                        ))}
                      </ul>
                      {uploadErrors.length > 50 && (
                        <div style={styles.errorMore}>
                          …and {uploadErrors.length - 50} more.
                        </div>
                      )}
                      <button
                        style={styles.cancelBtn}
                        onClick={() => this.setState({ uploadErrors: [] })}
                      >
                        Dismiss
                      </button>
                    </div>
                  )}

                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden", marginBottom: 20 }}>
                    <div style={styles.tableWrapper}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead style={styles.thead}>
                          <tr>
                            <th style={styles.th}>S.No</th>
                            <th style={styles.th}>Roll No</th>
                            <th style={styles.th}>Student Name</th>
                            <th style={styles.th}>Date of Birth</th>
                            <th style={styles.th}>Father Name</th>
                            <th style={styles.th}>Father Mobile</th>
                            <th style={styles.th}>Mother Name</th>

                            {internalColumns.map((col) => (
                              <th key={col.key} style={styles.th}>
                                {col.label}
                              </th>
                            ))}

                            <th style={styles.th}>Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          {studentsData?.length === 0 ? (
                            <tr>
                              <td colSpan={8 + internalColumns.length} style={styles.td}>
                                <div style={styles.emptyState}>
                                  <span style={styles.emptyIcon}>📭</span>
                                  <p style={styles.emptyText}>No data found</p>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            paginatedData.map((student, rowIndex) => {
                              const actualIndex = pageStartIndex + rowIndex;

                              return (
                                <tr key={student.student_id}>
                                  <td style={styles.td}>{actualIndex + 1}</td>
                                  <td style={styles.td}>{student.roll_no ?? "-"}</td>
                                  <td style={styles.td}>{student.student_name ?? "-"}</td>
                                  <td style={styles.td}>{student.dob ?? "-"}</td>
                                  <td style={styles.td}>{student.father_name ?? "-"}</td>
                                  <td style={styles.td}>{student.father_phone ?? "-"}</td>
                                  <td style={styles.td}>{student.mother_name ?? "-"}</td>

                                  {/* One cell per (subject, test) column. Matching
                                      must use both ids — exam_phase_internal_id is
                                      reused across subjects. */}
                                  {internalColumns.map((col) => {
                                    const int = (student.internals || []).find(
                                      (i) =>
                                        this.cellKey(i.subject_id, i.exam_phase_internal_id) ===
                                        col.key
                                    );

                                    if (!int) {
                                      return (
                                        <td style={styles.td} key={col.key}>
                                          —
                                        </td>
                                      );
                                    }

                                    return (
                                      <td style={styles.td} key={col.key}>
                                        <Form.Control
                                          type="number"
                                          size="sm"
                                          className="w-100"
                                          placeholder="Enter Marks"
                                          value={int.marks ?? ""}
                                          min={0}
                                          max={int.internal_max_marks}
                                          onChange={(e) =>
                                            this.handleMarksChange(
                                              actualIndex,
                                              int.subject_id,
                                              int.exam_phase_internal_id,
                                              e.target.value
                                            )
                                          }
                                          style={{ width: 70 }}
                                        />
                                      </td>
                                    );
                                  })}

                                  <td style={styles.td}>
                                    <span style={styles.standardPill}>
                                      {student.total_marks}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    {this.renderPagination()}
                  </div>

                  {/* Save */}
                  <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 12, marginTop: 12 }}>
                    {this.state.isDirty && (
                      <span style={{ fontSize: 13, color: "#b45309" }}>
                        You have unsaved marks.
                      </span>
                    )}
                    <button
                      style={styles.saveBtn}
                      onClick={this.handleSave}
                      disabled={this.state.isSubmit}
                    >
                      {this.state.isSubmit ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>

      </div>
    );
  }
}

export default withRouter(withApollo(compose(
  graphql(SAVE_EXAM_MARKS, {
    name: "saveExamMarks",
  }),
)(MarksEntry)
));